/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteInstrumentSyncEntityRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/DeleteInstrumentSyncEntity.pb'
import {DeleteInstrumentSyncEntityResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/DeleteInstrumentSyncEntity.pb'


export const deleteInstrumentSyncEntity = (request:DeleteInstrumentSyncEntityRequest, options?: CashRequestOptions) => post<DeleteInstrumentSyncEntityRequest, DeleteInstrumentSyncEntityResponse>("/2.0/cash/delete-instrument-sync-entity", request, {...options, rejectOnError: true })